import http from '../services/http.service'
import {
    ECompleteMethod,
    EEntranceOption,
    IEntranceChangeParams,
    IEntranceCodeChangeParams,
    IRequestReturnParams,
} from '../components/screens/tracking/type'
import {queries} from './queries'
import {showApiError, showMessage} from "../common/message";
import {entryPasswordRegex, passwordRegex} from "../common/regex";
import {MessageInstance} from "antd/es/message/interface";

export const putDeliveryComplete = (message: MessageInstance, t: (t: string) => string,
                                    {
                                        entrance_password,
                                        entrance_option,
                                        delivery_box_number,
                                        delivery_box_password,
                                        delivery_complete_on_info,
                                        delivery_complete_on,
                                        size,
                                        package_count,
                                        photo,
                                        save,
                                    }: IEntranceChangeParams,
                                    tracking_number?: string, onSuccess?: () => void) => {
    if (entrance_option === EEntranceOption.GATECODE) {
        //공동현관 비밀번호 선택시
        if (!entrance_password) {
            showMessage(message, t('popup.error.entry.code.empty'))
            return
        } else if (!!entrance_password && entryPasswordRegex.test(entrance_password)) {
            showMessage(message, t('popup.error.code.invalid'))
            return
        }
    }
    if (delivery_complete_on === ECompleteMethod.DELIVERYBOX) {
        //택배함 선택시
        if (!!delivery_box_password && !passwordRegex.test(delivery_box_password)) {
            showMessage(message, t('For the locker password, please enter only the special characters ‘#’ or ‘*’.'))
            return
        }
    } else if (delivery_complete_on === ECompleteMethod.OTHER) {
        if (!delivery_complete_on_info) {
            showMessage(message, t('popup.error.other.empty'))
            return
        }
    }
    const formData = new FormData()
    !!photo && formData.append('photo', photo, 'photo.png')
    !!size && formData.append('size', size)
    !!package_count && formData.append('package_count', package_count + '')
    !!delivery_complete_on && formData.append('delivery_complete_on', delivery_complete_on)
    !!delivery_complete_on_info && formData.append('delivery_complete_on_info', delivery_complete_on_info)
    !!entrance_option && formData.append('entrance_option', entrance_option)
    !!entrance_password && formData.append('entrance_password', entrance_password)
    !!delivery_box_number && formData.append('delivery_box_number', delivery_box_number)
    !!delivery_box_password && formData.append('delivery_box_password', delivery_box_password)
    !!save && formData.append('save', 'true')

    http
        .post(queries.shipping.deliveryinfo(tracking_number), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then((res) => {
        if (onSuccess) onSuccess();
    }).catch(error => {
        showApiError(error, message)
    })
}

export const postEntrance = (
    tracking_number: string,
    {information, entrance_option}: IEntranceCodeChangeParams,
) => {
    const formData: IEntranceCodeChangeParams = {}

    if (entrance_option) formData.entrance_option = entrance_option
    if (information) formData.information = information

    return http.post(queries.address.info(tracking_number), formData)
}

export const postReturn = (
    tracking_number: string,
    {order_items, return_memo, return_reason, process_return}: IRequestReturnParams
) => {
    return http.post(queries.shipping.return(tracking_number), {
        order_items,
        return_memo,
        return_reason,
        process_return,
    })
}

export const postReturnPhoto = (tracking_number: string, photo: File) => {
    const formData = new FormData()
    formData.append('photo', photo, photo.name)
    return http.post(queries.shipping.returnPhoto(tracking_number), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
